import { Fragment } from 'react'

export function getApplicantProfileOrderedWidgets({
  widgetListOrder,
  widgets,
}) {
  return widgetListOrder
    .filter(widgetKey => widgets[widgetKey])
    .map(widgetKey => <Fragment key={widgetKey}>{widgets[widgetKey]}</Fragment>)
}

export function getHasApplicantMatchedListing(applicantData) {
  return applicantData?.matched_listing
}
